import { Injectable } from '@angular/core';
import { SessionStorageService } from './session-storage.service';

export enum EtagEntityType {
    Contract = 0
}

export class EtagRecord {
    public eType: EtagEntityType;
    public id: number;
    etag: string;
}

@Injectable()
export class EtagService {
    constructor() {
    }

    public static getEtagEntity(eType: EtagEntityType, id: number): EtagRecord {
        //todo: ASSOC entity type with keysession.
        if (eType === EtagEntityType.Contract) {
            const recordList = SessionStorageService.optConcContract.get();
            if (!recordList) {
                console.error('optConcContract not found in session storage.');
                return;
            }
            const recordListObj = JSON.parse(recordList) as EtagRecord[];
            const foundRecords = recordListObj.filter(o => o.id === id);
            if (foundRecords) {
                return foundRecords[0];
            } else {
                console.error(id + ' not found into etag get entity.');
                return null;
            }
        }
    }

    private static getSafeListOpt(): Array<EtagRecord> {
        const optList = SessionStorageService.optConcContract.get();
        if (optList) {
            return JSON.parse(optList) as EtagRecord[];
        }
        return [] as EtagRecord[];
    }

    public setEtagEntity(record: EtagRecord) {
        if (!record) {
            console.error('record is empty!');
            return;
        }
        if (!record.etag) {
            console.error('etag is empty!');
            return;
        }
        if (record.id === null || typeof record.id === 'undefined') {
            console.error('record.id is empty!');
            return;
        }
        if (record.eType === EtagEntityType.Contract) {
            this._setOrCreate(record);
            return;
        }
        console.error(record.eType + ' not found as EtagEntityType.');
    }

    private _setOrCreate(record: EtagRecord): void {
        const listOpt = EtagService.getSafeListOpt();
        const recordFound = listOpt.filter(o => o.id === record.id);
        if (recordFound.length > 0) {
            recordFound.forEach(o => (o.etag = record.etag));
        } else {
            listOpt.push(record);
        }
        SessionStorageService.optConcContract.save(JSON.stringify(listOpt));
    }
}



// WEBPACK FOOTER //
// ./src/app/services/etag.service.ts